import { Button, Radio, Select, Space, Typography } from 'antd';

const { Paragraph, Text } = Typography;

/*
 * Rechargement des classes. La transition resynchronise les enseignants qu'elle conserve,
 * mais certains restent en arrière — exécution lancée sans resynchronisation, appels Edifice
 * en échec, compte hors du périmètre purgé. Ce panneau les rattrape sans attendre leur
 * prochaine connexion.
 */
const ClassesPanel = ({
  askConfirm,
  classPlatforms,
  job,
  knownPlatforms,
  launch,
  onlyStale,
  running,
  setClassPlatforms,
  setOnlyStale,
  simulationOk,
}) => (
  <Space direction="vertical" size="middle" style={{ width: '100%' }}>
    <Paragraph type="secondary">
      Recharge depuis Edifice les classes, les effectifs et les parents, pour les enseignants des plateformes choisies. Les élèves
      qui ont quitté une classe en sont retirés, ceux qui l&apos;ont rejointe y sont ajoutés. Une classe dont l&apos;appel Edifice
      échoue n&apos;est jamais vidée.
    </Paragraph>

    <Space direction="vertical" size={2} style={{ width: '100%' }}>
      <Text type="secondary">Plateformes</Text>
      <Select
        allowClear
        mode="multiple"
        disabled={running}
        onChange={value => setClassPlatforms(value || [])}
        options={knownPlatforms.map(p => ({ label: p, value: p }))}
        placeholder="Choisir une ou plusieurs plateformes"
        style={{ maxWidth: 700, width: '100%' }}
        value={classPlatforms}
      />
    </Space>

    <Space direction="vertical" size={2}>
      <Text type="secondary">Périmètre</Text>
      <Radio.Group disabled={running} onChange={e => setOnlyStale(e.target.value)} value={onlyStale}>
        <Radio value>Enseignants en retard seulement</Radio>
        <Radio value={false}>Tous les enseignants</Radio>
      </Radio.Group>
      <Text type="secondary">
        « En retard » : aucune classe rattachée depuis la rentrée de leur plateforme. Tout recharger représente un appel Edifice par
        enseignant et par classe — à réserver aux petits périmètres.
      </Text>
    </Space>

    <Space>
      <Button disabled={classPlatforms.length === 0 || running} loading={running && job.dryRun} onClick={() => launch(true)}>
        Simuler
      </Button>
      <Button
        type="primary"
        disabled={!simulationOk || running}
        loading={running && !job.dryRun}
        onClick={() =>
          askConfirm({
            description: `Les classes et les effectifs seront rechargés depuis Edifice pour ${
              onlyStale ? 'les enseignants en retard' : 'tous les enseignants'
            } de ${classPlatforms.join(', ')}.`,
            expected: [...classPlatforms].sort().join(','),
            kind: 'classes',
            title: 'Confirmer le rechargement des classes',
          })
        }>
        Recharger les classes
      </Button>
      {!simulationOk && classPlatforms.length > 0 && <Text type="secondary">Lancer d&apos;abord une simulation.</Text>}
    </Space>
  </Space>
);

export default ClassesPanel;
